import { LotowheelModalTemplates } from './lotowheel-modals.js';
import { nodoModal } from './modals/nodo-modal.js';
import { contratoModal } from './modals/contrato-modal-template.js';
import { pozoAcumuladoModal } from './modals/pozo-acumulado-modal.js';
import { MonedaService } from '../services/moneda-service.js';
import { ConfirmacionDestructiva } from './confirmacion-destructiva.js';
import { t } from '../services/i18n-admin.js';
import { LIMITES_COPY_EDITORIAL } from '@shared/contracts/copy-editorial-de-promocion.js';
import { icon } from '../utils/icon.js';

/**
 * Modal Templates - Componentes HTML de modales
 *
 * Genera el HTML de los modales dinámicamente para reducir el tamaño de index.html
 * Los modales se inyectan en #modalOverlay al cargar la página
 */

export const ModalTemplates = {
    // LotoWheel config delegado a LotowheelModalTemplates (lotowheel-modals.js)
    lotowheelConfig() {
        if (typeof LotowheelModalTemplates === 'undefined') return '';
        return LotowheelModalTemplates.config();
    },

    /**
     * Modal de TV (Autorizar/Editar)
     */
    dispositivo() {
        return `
    <div class="modal" id="modalDispositivo" style="display:none; max-width:500px;">
      <div class="modal-header">
        <h2 id="modalDispositivoTitle">${t('Autorizar Dispositivo')}</h2>
        <button class="btn-icon" data-action="app:closeModal">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body" style="display:block; padding:24px;">
        <input type="hidden" id="dispositivoId">
        <input type="hidden" id="dispositivoCodigo">

        <!-- Codigo (solo flujo autorización de screens) -->
        <div class="form-group" id="dispositivoInfoGroup" style="display:none;">
          <div style="background:var(--bg-tertiary); padding:12px; border-radius:8px; margin-bottom:16px;">
            <div style="font-size:12px; color:var(--text-secondary); margin-bottom:4px;">${t('Codigo del Dispositivo')}</div>
            <div id="dispositivoCodigoDisplay" style="font-family:monospace; font-size:20px; letter-spacing:2px; color:var(--accent-orange);"></div>
          </div>
        </div>

        <!-- 1. Nodo (contexto jerárquico, primero para cajas) -->
        <div class="form-group" id="dispNodoGroup">
          <label class="form-label">${t('Nodo (Local Fisico)')}</label>
          <input type="hidden" id="dispositivoNodoId">
          <div id="dispositivoNodoSearchContainer"></div>
          <div class="form-hint" style="margin-top:4px;">${t('Escribe para buscar o')} <a href="#" data-action="dispositivos:openNodoModalFromDispositivo" style="color:var(--accent-blue);">${t('crear nuevo nodo')}</a></div>
        </div>

        <!-- 2. Nombre -->
        <div class="form-group">
          <label class="form-label">${t('Nombre (opcional)')}</label>
          <input type="text" class="form-input" id="dispositivoNombre" placeholder="${t('ej: Screen Entrada, VLT Mesa 3')}">
          <div class="form-hint">${t('Para identificar facilmente este dispositivo')}</div>
        </div>

        <!-- 3. Operaciones (solo cajas) — vertical: cada check con su panel debajo -->
        <div id="dispositivoOperacionesGroup" style="display:none;">
          <!-- Recargas Wallet -->
          <div class="form-group" style="margin-bottom:4px;">
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer; font-weight:600;">
              <input type="checkbox" id="dispOpWallet" checked data-action="dispositivos:onOperacionesChange" data-param="disp"> ${t('Recargas Wallet')}
            </label>
          </div>
          <div id="dispWalletPanel" style="display:none;"></div>

          <!-- Venta de Tickets -->
          <div class="form-group" style="margin-bottom:4px;">
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer; font-weight:600;">
              <input type="checkbox" id="dispOpTickets" checked data-action="dispositivos:onOperacionesChange" data-param="disp"> ${t('Venta de Tickets')}
            </label>
          </div>

          <!-- Sorteos asignados (tabla dispositivo_sorteo_assignments). -->
          <div id="dispSorteoAssignmentsPanel" style="display:none;"></div>

          <!-- Restricciones de apuesta + chips (config.juegos). Radio independiente del de sorteos. -->
          <div id="dispGamePanel" style="display:none;"></div>

          <!-- Impresión POS (caja) — paper width, copias default, override de code128 -->
          <div class="form-group" style="margin-top:16px; padding-top:12px; border-top:1px solid var(--border);">
            <label style="display:block; font-weight:600; margin-bottom:8px;">${t('Impresión POS')}</label>
            <div class="form-hint" style="margin-bottom:10px;">${t('Políticas de impresión específicas de esta caja. Vacío = heredar del nodo / default.')}</div>

            <div style="display:flex; gap:12px; flex-wrap:wrap;">
              <div style="flex:1; min-width:120px;">
                <label class="form-label" style="font-size:11px;">${t('Ancho de papel')}</label>
                <select class="form-select" id="dispPrintingPaperWidthMm">
                  <option value="">${t('Heredar (58mm)')}</option>
                  <option value="58">58mm</option>
                  <option value="80">80mm</option>
                </select>
              </div>
              <div style="flex:1; min-width:120px;">
                <label class="form-label" style="font-size:11px;">${t('Copias default')}</label>
                <input type="number" class="form-input" id="dispPrintingCopiasDefault"
                       min="1" max="5" placeholder="1">
              </div>
            </div>

            <div class="form-group" style="margin-top:10px;">
              <label class="form-label" style="font-size:11px;">${t('Imprimir Code128 (override)')}</label>
              <select class="form-select" id="dispPrintingImprimirCodeBar">
                <option value="">${t('Heredar del nodo')}</option>
                <option value="true">${t('Forzar: sí imprimir')}</option>
                <option value="false">${t('Forzar: no imprimir')}</option>
              </select>
              <div class="form-hint">${t('Regla dura: si no hay QR y se elige "no", se fuerza a "sí" (ticket siempre con código escaneable).')}</div>
            </div>
          </div>
        </div>

        <!-- Fallback: selector simple de game type + sorteos para screens -->
        <div id="dispScreenSorteosSection">
          <div class="form-group" id="dispGameTypeGroup">
            <label class="form-label">${t('Tipo de Juego')}</label>
            <select class="form-select" id="dispositivoGameType" data-action="dispositivos:onGameTypeChange"></select>
          </div>
          <div class="form-group" id="dispositivoSorteosGroup" style="display:none;">
            <label class="form-label">${t('Asignar Sorteos')}</label>
            <div id="dispositivoSorteosContainer" class="sorteos-check-list"></div>
            <div class="form-hint" style="margin-top:8px;">${t('Selecciona los sorteos que operara este dispositivo')}</div>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="justify-content: space-between;">
        <button class="btn btn-warning" id="dispositivoReiniciarBtn" data-action="dispositivos:reiniciar" style="display:none;" title="${t('Limpia caché y recarga la TV remotamente')}">${t('Reiniciar TV')}</button>
        <div style="display:flex; gap:8px;">
          <button class="btn btn-secondary" data-action="app:closeModal">${t('Cancelar')}</button>
          <button class="btn btn-primary" id="dispositivoSaveBtn" data-action="dispositivos:save">${t('Autorizar')}</button>
        </div>
      </div>
    </div>`;
    },

    /**
     * Modal de Bloqueo
     */
    bloqueo() {
        return `
    <div class="modal" id="modalBloqueo" style="display:none; max-width:500px;">
      <div class="modal-header">
        <h2>${t('Nuevo Bloqueo')}</h2>
        <button class="btn-icon" data-action="app:closeModal">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body" style="display:block; padding:24px;">
        <div class="form-group">
          <label class="form-label">${t('Tipo')}</label>
          <select class="form-select" id="bloqueoTipo">
            <option value="tv">${t('TV (por serial)')}</option>
            <option value="cliente">${t('Cliente (por telefono)')}</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-label">${t('Identificador')}</label>
          <input type="text" class="form-input" id="bloqueoIdentificador" placeholder="${t('Serial de TV o telefono')}">
        </div>
        <div class="form-group">
          <label class="form-label">${t('Motivo')}</label>
          <select class="form-select" id="bloqueoMotivo">
            <option value="clonada">${t('TV Clonada')}</option>
            <option value="moroso">${t('Cliente Moroso')}</option>
            <option value="fraude">${t('Fraude')}</option>
            <option value="otro">${t('Otro')}</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-label">${t('Notas (opcional)')}</label>
          <textarea class="form-input" id="bloqueoNotas" rows="2"></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-action="app:closeModal">${t('Cancelar')}</button>
        <button class="btn btn-primary" data-action="lotowheel:saveBloqueo">${t('Bloquear')}</button>
      </div>
    </div>`;
    },

    /**
     * Modal de Sorteo (Detalle)
     */
    sorteo() {
        return `
    <div class="modal" id="modalSorteo" style="display:none; max-width:700px;">
      <div class="modal-header">
        <h2 id="modalSorteoTitle">${t('Sorteo #')}0</h2>
        <button class="btn-icon" data-action="app:closeModal">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body" style="display:block; padding:24px;">
        <div class="sorteo-detail-header">
          <div class="sorteo-numero-grande" id="sorteoNumeroGrande"><span class="skeleton-bar" style="display:inline-block;width:40px;height:20px;"></span></div>
          <div class="sorteo-stats">
            <div class="sorteo-stat">
              <span class="stat-label">${t('Jugado')}</span>
              <span class="stat-value" id="sorteoApostado"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></span>
            </div>
            <div class="sorteo-stat">
              <span class="stat-label">${t('Pagado')}</span>
              <span class="stat-value" id="sorteoPagado"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></span>
            </div>
            <div class="sorteo-stat">
              <span class="stat-label">RTP</span>
              <span class="stat-value" id="sorteoRTP"><span class="skeleton-bar" style="display:inline-block;width:50px;height:20px;"></span></span>
            </div>
          </div>
        </div>
        <div class="form-group">
          <input type="text" class="form-input" id="sorteoSearch" placeholder="${t('Buscar por telefono, punto de venta, tipo...')}">
        </div>
        <div class="sorteo-apuestas-list" id="sorteoApuestasList"></div>
      </div>
    </div>`;
    },

    /**
     * Modal de Usuario
     */
    usuario() {
        return `
    <div class="modal" id="modalUsuario" style="display:none; max-width:500px;">
      <div class="modal-header">
        <h2 id="modalUsuarioTitle">${t('Nuevo Usuario')}</h2>
        <button class="btn-icon" data-action="app:closeModal">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body" style="display:block; padding:24px;">
        <input type="hidden" id="usuarioId">
        <div class="form-group">
          <label class="form-label">${t('Nombre')}</label>
          <input type="text" class="form-input" id="usuarioNombre" placeholder="${t('Juan Perez')}" required>
        </div>
        <div class="form-group">
          <label class="form-label">${t('Email')}</label>
          <input type="email" class="form-input" id="usuarioEmail" placeholder="${t('juan@empresa.com')}" required>
        </div>
        <div class="form-group">
          <label class="form-label">${t('Contrasena')}</label>
          <div style="display:flex;gap:8px;align-items:center">
            <div style="position:relative;flex:1">
              <input type="password" class="form-input" id="usuarioPassword" placeholder="••••••••" style="padding-right:40px">
              <button type="button" data-action="admin:togglePasswordVisibility"
                      style="position:absolute;right:8px;top:50%;transform:translateY(-50%);background:none;border:none;cursor:pointer;opacity:0.6;padding:4px"
                      title="${t('Mostrar/ocultar')}">
                ${icon('eye', '', { id: 'passwordToggleIcon' })}
              </button>
            </div>
            <button type="button" class="btn btn-sm btn-secondary" data-action="admin:generateSecurePassword"
                    style="white-space:nowrap;flex-shrink:0">${t('Generar')}</button>
          </div>
          <small class="form-hint" id="passwordHint">${t('Minimo 6 caracteres')}</small>
        </div>
        <div class="form-group" id="passwordConfirmGroup">
          <label class="form-label">${t('Confirmar Contrasena')}</label>
          <input type="password" class="form-input" id="usuarioPasswordConfirm" placeholder="••••••••">
        </div>
        <div class="form-group">
          <label class="form-label">${t('Rol')}</label>
          <select class="form-select" id="usuarioRol" data-action="platform:onRolChange">
            <option value="superadmin">${t('Super Admin (acceso total)')}</option>
            <option value="operador">${t('Operador')}</option>
            <option value="representante">${t('Representante')}</option>
            <option value="punto_venta">${t('Encargado de Punto de Venta')}</option>
            <option value="cajero">${t('Cajero')}</option>
          </select>
        </div>
        <div class="form-group" id="entidadGroup" style="display:none;">
          <label class="form-label" id="entidadLabel">${t('Nodo Asignado')}</label>
          <small class="form-hint" id="entidadHint" style="margin-bottom:4px; display:block;"></small>
          <div id="entidadSearchContainer"></div>
          <input type="hidden" id="usuarioEntidad" />
        </div>
        <div class="form-group" id="cajaDispositivoGroup" style="display:none;">
          <label class="form-label">${t('Caja Asignada *')}</label>
          <small class="form-hint" style="margin-bottom:4px; display:block;">${t('Dispositivo fisico donde opera el cajero')}</small>
          <select class="form-select" id="usuarioCajaDispositivo">
            <option value="">${t('Seleccionar caja...')}</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-label">${t('Estado')}</label>
          <select class="form-select" id="usuarioActivo">
            <option value="1">${t('Activo')}</option>
            <option value="0">${t('Inactivo')}</option>
          </select>
        </div>
        <div class="form-group" id="capabilitiesGroup" style="display:none;">
          <label class="form-label">${t('Permisos')}</label>
          <small class="form-hint" style="margin-bottom:8px; display:block;">${t('Personalizar permisos. Sin cambios = permisos por defecto del rol.')}</small>
          <div id="capabilitiesGrid" style="display:grid; grid-template-columns:1fr 1fr; gap:4px 16px; padding:8px; border:1px solid var(--border-color); border-radius:8px; background:var(--bg-secondary); max-height:250px; overflow-y:auto; scrollbar-width:none;"></div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-action="app:closeModal">${t('Cancelar')}</button>
        <button class="btn btn-primary" data-action="platform:saveUsuario">${t('Guardar')}</button>
      </div>
    </div>`;
    },

    // Modal chico de MOVER usuario: reasigna a otro PV (+ caja si es cajero) sin
    // el formulario completo de Editar. Solo el selector de nodo destino (filtrado
    // por subárbol del admin — no se puede mover fuera del nivel propio) y, para
    // cajeros, la caja. El selector de nodo lo monta PlatformAdministradores.mover()
    // reusando el FuzzySearchInput.
    moverUsuario() {
        return `
    <div class="modal" id="modalMoverUsuario" style="display:none; max-width:460px;">
      <div class="modal-header">
        <h2>${t('Mover')} <span id="moverUsuarioNombre"></span></h2>
        <button class="btn-icon" data-action="app:closeModal">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body" style="display:block; padding:24px;">
        <input type="hidden" id="moverUsuarioId">
        <input type="hidden" id="moverUsuarioRol">
        <div class="form-group">
          <label class="form-label" id="moverUsuarioNodoLabel">${t('Nuevo punto de venta')}</label>
          <small class="form-hint" style="margin-bottom:4px; display:block;">${t('Solo se listan nodos de tu red. No se puede mover fuera de tu nivel.')}</small>
          <div id="moverUsuarioNodoContainer"></div>
          <input type="hidden" id="moverUsuarioNodo" />
        </div>
        <div class="form-group" id="moverUsuarioCajaGroup" style="display:none;">
          <label class="form-label">${t('Caja asignada')}</label>
          <small class="form-hint" style="margin-bottom:4px; display:block;">${t('Dispositivo físico donde opera el cajero.')}</small>
          <select class="form-select" id="moverUsuarioCaja">
            <option value="">${t('Seleccionar caja...')}</option>
          </select>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-action="app:closeModal">${t('Cancelar')}</button>
        <button class="btn btn-primary" data-action="entidades:guardarMover">${t('Mover')}</button>
      </div>
    </div>`;
    },

    /**
     * Modal de Estadísticas (genérico, reutilizable)
     * Se usa para mostrar stats de cajas, representantes, puntos de venta, etc.
     * Incluye filtros de fecha: hoy, ayer, semana, mes, ultimo corte, rango personalizado
     */
    stats() {
        return `
    <div class="modal" id="modalStats" style="display:none; max-width:520px;">
      <div class="modal-header">
        <h2 id="modalStatsTitle">${t('Estadisticas')}</h2>
        <button class="btn-icon" data-action="app:closeModal">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body" style="display:block; padding:24px;">
        <!-- Filtros de fecha -->
        <div class="stats-date-filters" style="display:flex; flex-wrap:wrap; gap:6px; margin-bottom:16px;">
          <button class="btn btn-sm stats-date-btn active" data-period="hoy" data-action="stats:setPeriod">${t('Hoy')}</button>
          <button class="btn btn-sm stats-date-btn" data-period="ayer" data-action="stats:setPeriod">${t('Ayer')}</button>
          <button class="btn btn-sm stats-date-btn" data-period="semana" data-action="stats:setPeriod">${t('Semana')}</button>
          <button class="btn btn-sm stats-date-btn" data-period="mes" data-action="stats:setPeriod">${t('Mes')}</button>
          <button class="btn btn-sm stats-date-btn" data-period="ultimo_corte" data-action="stats:setPeriod">${t('Ultimo Corte')}</button>
          <button class="btn btn-sm stats-date-btn" data-period="rango" data-action="stats:toggleRangoInputs">${t('Rango')}</button>
        </div>
        <!-- Inputs de rango personalizado (ocultos por defecto) -->
        <div id="statsRangoInputs" style="display:none; margin-bottom:16px;">
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">${t('Desde')}</label>
              <input type="date" class="form-input" id="statsDesde">
            </div>
            <div class="form-group">
              <label class="form-label">${t('Hasta')}</label>
              <input type="date" class="form-input" id="statsHasta">
            </div>
            <div class="form-group" style="display:flex; align-items:flex-end;">
              <button class="btn btn-primary btn-sm" data-action="stats:applyRango">${t('Aplicar')}</button>
            </div>
          </div>
        </div>
        <!-- Indicador de carga -->
        <div id="statsLoading" style="display:none; text-align:center; padding:20px;">
          ${icon('refresh-cw', 'spin', { style: 'width:24px; height:24px;' })}
          <div style="margin-top:8px; color:var(--text-secondary);">${t('Cargando...')}</div>
        </div>
        <!-- Contenido de stats -->
        <div id="modalStatsContent" style="font-family:monospace; font-size:14px; line-height:1.8; background:var(--bg-tertiary); padding:16px; border-radius:8px; white-space:pre-wrap;"></div>
        <!-- Metadata oculta para refrescar -->
        <input type="hidden" id="statsEntityType">
        <input type="hidden" id="statsEntityId">
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-action="app:copyStatsToClipboard">
          ${icon('copy')}
          ${t('Copiar')}
        </button>
        <button class="btn btn-primary" data-action="app:closeModal">${t('Cerrar')}</button>
      </div>
    </div>`;
    },

    /**
     * Modal de Corte de Caja
     */
    corte() {
        return `
    <div class="modal" id="modalCorte" style="display:none; max-width:500px;">
      <div class="modal-header">
        <h2>${t('Nuevo Corte de Caja')}</h2>
        <button class="btn-icon" data-action="app:closeModal">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body" style="display:block; padding:24px;">
        <p style="color:var(--text-secondary); font-size:13px; margin-bottom:16px;">
          ${t('Genera el corte de')} <strong>${t('un solo nodo')}</strong>. ${t('Para cerrar también todos sus hijos, usa Corte en Cascada.')}
        </p>
        <div class="form-group">
          <label class="form-label">${t('Nodo *')}</label>
          <input type="hidden" id="cortePuntoVentaId">
          <div id="cortePuntoVentaSearchContainer"></div>
          <div class="form-hint" style="margin-top:4px;">${t('Seleccione el nodo para cerrar corte')}</div>
        </div>
        <div id="corteBalancePreview" style="display:none; margin-top:16px;">
          <div style="background:var(--bg-tertiary); padding:16px; border-radius:8px;">
            <h4 style="margin:0 0 12px 0; font-size:14px; color:var(--text-secondary);">${t('Balance Proyectado')}</h4>
            <div style="display:grid; grid-template-columns:1fr 1fr; gap:12px;">
              <div>
                <div style="font-size:12px; color:var(--text-secondary);">${t('Jugado')}</div>
                <div id="corteApostado" style="font-size:18px; font-weight:600; color:var(--accent-green);"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
              </div>
              <div>
                <div style="font-size:12px; color:var(--text-secondary);">${t('Pagado')}</div>
                <div id="cortePagado" style="font-size:18px; font-weight:600; color:var(--accent-blue);"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
              </div>
              <div>
                <div style="font-size:12px; color:var(--text-secondary);">${t('GGR')}</div>
                <div id="corteNetwin" style="font-size:18px; font-weight:600;"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
              </div>
              <div>
                <div style="font-size:12px; color:var(--text-secondary);">${t('Comisión propia')}</div>
                <div id="corteComision" style="font-size:18px; font-weight:600; color:var(--accent-orange);"><span class="skeleton-bar" style="display:inline-block;width:70px;height:20px;"></span></div>
                <div id="corteComisionRede" style="font-size:12px; color:var(--text-secondary); margin-top:2px;"></div>
              </div>
            </div>
            <div id="corteAvisoHijos" style="display:none; margin-top:12px; font-size:12px; padding:8px 10px; border-radius:6px; background:rgba(255,152,0,0.08); border:1px solid var(--accent-orange); color:var(--accent-orange);"></div>
          </div>
          <!-- Rango del cierre (IMAGEN 1): desde = última fecha cerrada (read-only, continuidad sin
               huecos); hasta = selector re-habilitado (default fin de ayer, tope ahora). El backend
               acepta fecha pasada midiendo el remanente del ledger (cierre retroactivo,
               remanente-contadores-posterior.js) — el aviso de "no disponible" ya no aplica. -->
          <div style="display:flex; gap:16px; margin-top:12px; flex-wrap:wrap;">
            <div style="flex:1; min-width:160px;">
              <div style="font-size:12px; color:var(--text-secondary);">${t('Desde (último cierre)')}</div>
              <div id="corteDesde" style="font-size:14px; font-weight:600; padding:6px 0;"><span class="skeleton-bar" style="display:inline-block;width:130px;height:17px;"></span></div>
            </div>
            <div style="flex:1; min-width:160px;">
              <label class="form-label" style="font-size:12px;">${t('Cerrar hasta')}</label>
              <input type="datetime-local" class="form-input" id="corteHasta" />
            </div>
          </div>
        </div>
        <div class="form-group" style="margin-top:16px;">
          <label class="form-label">${t('Observaciones (opcional)')}</label>
          <textarea class="form-input" id="corteObservaciones" rows="2" placeholder="${t('Notas sobre el corte...')}"></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-action="app:closeModal">${t('Cancelar')}</button>
        <button class="btn btn-primary" id="btnGuardarCorte" data-action="finanzas:saveCorte" disabled>
          ${icon('scissors')}
          ${t('Cerrar Corte')}
        </button>
      </div>
    </div>`;
    },

    /**
     * Modal de Historial de Cuenta Corriente
     */
    historialCuenta() {
        return `
    <div class="modal" id="modalHistorialCuenta" style="display:none; max-width:700px;">
      <div class="modal-header">
        <h2 id="modalHistorialCuentaTitle">${t('Historial de Cuenta')}</h2>
        <button class="btn-icon" data-action="app:closeModal">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body" style="display:block; padding:24px;">
        <div class="table-container" style="max-height:400px; overflow-y:auto;">
          <table>
            <thead>
              <tr>
                <th>${t('Fecha')}</th>
                <th>${t('Tipo')}</th>
                <th>${t('Monto')}</th>
                <th>${t('Descripcion')}</th>
              </tr>
            </thead>
            <tbody id="historialCuentaTable"></tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-action="app:closeModal">${t('Cerrar')}</button>
      </div>
    </div>`;
    },

    /**
     * Modal de Ajuste Manual de Cuenta Corriente (solo superadmin)
     */
    ajusteCuenta() {
        return `
    <div class="modal" id="modalAjusteCuenta" style="display:none; max-width:420px;">
      <div class="modal-header">
        <h2>${t('Ajuste Manual de Cuenta')}</h2>
        <button class="btn-icon" data-action="app:closeModal">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body" style="display:block; padding:24px;">
        <div style="background:rgba(255,152,0,0.1); border:1px solid var(--accent-orange); border-radius:8px; padding:10px 14px; font-size:13px; color:var(--accent-orange); margin-bottom:16px;">
          ${t('Operación de solo superadmin. Modifica el saldo directamente sin generar movimiento de cliente. Queda registrado en auditoría.')}
        </div>
        <div class="form-group">
          <label class="form-label">${t('Nodo *')}</label>
          <select class="form-select" id="ajusteNodoId">
            <option value="">${t('Cargando nodos...')}</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-label">${t('Monto (positivo = abono, negativo = cargo) *')}</label>
          <input type="number" class="form-input" id="ajusteMonto" step="0.01" placeholder="${t('Ej: 100.00 o -50.00')}">
        </div>
        <div class="form-group">
          <label class="form-label">${t('Concepto')}</label>
          <input type="text" class="form-input" id="ajusteConcepto" placeholder="${t('Motivo del ajuste...')}">
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-action="app:closeModal">${t('Cancelar')}</button>
        <button class="btn btn-warning" id="btnGuardarAjuste" data-action="finanzas:saveAjusteCuenta">
          ${icon('sliders')}
          ${t('Aplicar Ajuste')}
        </button>
      </div>
    </div>`;
    },

    /**
     * Modal de Pago de Liquidación
     */
    pagoLiquidacion() {
        return `
    <div class="modal" id="modalPagoLiquidacion" style="display:none; max-width:420px;">
      <div class="modal-header">
        <h2>${t('Registrar Pago')}</h2>
        <button class="btn-icon" data-action="app:closeModal">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body" style="display:block; padding:24px;">
        <div class="form-group">
          <label class="form-label">${t('Monto (vacío = pago total)')}</label>
          <input type="number" class="form-input" id="pagoLiqMonto" min="0.01" step="0.01" placeholder="${t('0.00 — dejar vacío para total')}">
        </div>
        <div class="form-group">
          <label class="form-label">${t('Método *')}</label>
          <select class="form-select" id="pagoLiqMetodo">
            <option value="efectivo">${t('Efectivo')}</option>
            <option value="transferencia">${t('Transferencia')}</option>
            <option value="yape">Yape</option>
            <option value="plin">Plin</option>
            <option value="cheque">${t('Cheque')}</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-label">${t('Referencia (opcional)')}</label>
          <input type="text" class="form-input" id="pagoLiqReferencia" placeholder="${t('Nº operación, etc.')}">
        </div>
        <div class="form-group">
          <label class="form-label">${t('Notas (opcional)')}</label>
          <textarea class="form-input" id="pagoLiqNotas" rows="2" placeholder="${t('Observaciones...')}"></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-action="app:closeModal">${t('Cancelar')}</button>
        <button class="btn btn-success" id="btnGuardarPagoLiq" data-action="finanzas:savePagoLiquidacion">
          ${icon('banknote')}
          ${t('Confirmar Pago')}
        </button>
      </div>
    </div>`;
    },

    /**
     * Modal de Cortes en Cascada
     */
    corteCascada() {
        return `
    <div class="modal" id="modalCorteCascada" style="display:none; max-width:900px;">
      <div class="modal-header">
        <h2>${t('Cortes en Cascada')}</h2>
        <button class="btn-icon" data-action="app:closeModal">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body" style="display:block; padding:24px;">
        <p style="color:var(--text-secondary); font-size:13px; margin-bottom:16px;">
          ${t('Genera un corte de caja para el nodo seleccionado y')} <strong>${t('todos sus hijos')}</strong> ${t('de forma automática (bottom-up).')}
        </p>
        <div class="form-group">
          <label class="form-label">${t('Nodo raíz de la cascada *')}</label>
          <div id="cascadaNodoSearchContainer"></div>
          <p style="color:var(--text-tertiary); font-size:11px; margin-top:6px;">
            ${t('Solo nodos con sub-nodos (la cascada cierra desde las hojas hacia arriba).')}
          </p>
        </div>
        <!-- Rango ANTES de la prévia: el flujo es nodo → calcular → prévia → ejecutar.
             hasta = selector re-habilitado (default fin de ayer, tope ahora): el backend acepta
             fecha pasada midiendo el remanente del ledger (cierre retroactivo). La prévia
             CONGELADA sigue deshabilitada (feature aparte, sin plumbing de consumo) — la prévia
             en vivo y la ejecución directa con este 'hasta' funcionan. -->
        <div style="display:flex; gap:16px; margin-top:12px; flex-wrap:wrap;">
          <div style="flex:1; min-width:150px;">
            <div style="font-size:12px; color:var(--text-secondary);">${t('Desde (último cierre)')}</div>
            <div id="cascadaDesde" style="font-size:14px; font-weight:600; padding:6px 0;"><span class="skeleton-bar" style="display:inline-block;width:130px;height:17px;"></span></div>
          </div>
          <div style="flex:1; min-width:150px;">
            <label class="form-label" style="font-size:12px;">${t('Cerrar hasta')}</label>
            <input type="datetime-local" class="form-input" id="cascadaHasta" />
          </div>
        </div>
        <button class="btn btn-secondary" id="btnCalcularPreviaCascada" data-action="finanzas:calcularPreviaCascada" disabled style="width:100%; margin-top:12px;">
          ${t('Calcular prévia')}
        </button>
        <div id="cascadaPreview" style="margin-top:12px;"></div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-action="app:closeModal">${t('Cancelar')}</button>
        <button class="btn btn-outline" id="btnExportarPreviaCascada" data-action="finanzas:exportarPreviaCascada" disabled title="${t('Prévia — no es el cierre real, solo cómo quedaría si se ejecutara ahora.')}">
          ${icon('file-spreadsheet')}
          ${t('Exportar prévia')}
        </button>
        <button class="btn btn-primary" id="btnGuardarCascada" data-action="finanzas:saveCorteCascada">
          ${icon('git-branch')}
          ${t('Ejecutar Cascada')}
        </button>
      </div>
    </div>`;
    },

    /**
     * Modal Resolver Disputa de fechamento — 2 pasos (decidir → ver cómo quedará → confirmar).
     * El fechamento sellado NO se modifica: se crea una nota de ajuste (±) en la cuenta
     * corriente del nodo (estándar nota de crédito/débito) y el corte pasa a 'resuelto'.
     */
    resolverDisputaModal() {
        return `
    <div class="modal" id="modalResolverDisputa" style="display:none; max-width:560px;">
      <div class="modal-header">
        <h2>${t('Resolver disputa del fechamento')}</h2>
        <button class="btn-icon" data-action="app:closeModal">${icon('x')}</button>
      </div>
      <div class="modal-body" style="display:block; padding:24px;">
        <div id="resolverDisputaPaso1">
          <div id="resolverDisputaResumen" style="background:rgba(255,255,255,0.03); border:1px solid var(--border-glass); border-radius:8px; padding:12px 14px; font-size:13px; margin-bottom:12px;"></div>
          <div style="background:rgba(59,130,246,0.08); border:1px solid var(--accent-blue,#3b82f6); border-radius:8px; padding:10px 14px; font-size:12px; color:var(--text-secondary); margin-bottom:14px;">
            ${t('El fechamento sellado NO se modifica. Se crea una nota de ajuste en la cuenta corriente del nodo y el fechamento pasa a resuelto. Reversible solo con otra nota.')}
          </div>
          <div class="form-group">
            <label class="form-label">${t('Tipo de resolución *')}</label>
            <label style="display:block; font-size:13px; padding:4px 0;"><input type="radio" name="resolverDisputaTipo" value="credito"> ${t('Acreditar al nodo (+) — se le pagó de menos')}</label>
            <label style="display:block; font-size:13px; padding:4px 0;"><input type="radio" name="resolverDisputaTipo" value="debito"> ${t('Debitar al nodo (−) — se le pagó de más')}</label>
            <label style="display:block; font-size:13px; padding:4px 0;"><input type="radio" name="resolverDisputaTipo" value="sin_ajuste"> ${t('Sin ajuste económico — solo marcar resuelto')}</label>
          </div>
          <div class="form-group">
            <label class="form-label">${t('Monto del ajuste')}</label>
            <input type="number" class="form-input" id="resolverDisputaMonto" min="0" step="0.01" placeholder="0.00" disabled />
          </div>
          <div class="form-group">
            <label class="form-label">${t('Motivo (obligatorio) *')}</label>
            <textarea class="form-input" id="resolverDisputaMotivo" rows="3" placeholder="${t('Qué pasó y qué se acordó con el operador (mínimo 10 caracteres)')}"></textarea>
          </div>
          <button class="btn btn-primary" id="btnResolverDisputaContinuar" data-action="finanzas:continuarResolverDisputa" disabled style="width:100%;">${t('Continuar — ver cómo quedará')}</button>
        </div>
        <div id="resolverDisputaPaso2" style="display:none;">
          <div id="resolverDisputaPreview"></div>
          <div style="display:flex; gap:10px; margin-top:14px;">
            <button class="btn btn-secondary" data-action="finanzas:volverResolverDisputa" style="flex:1;">${t('Volver')}</button>
            <button class="btn btn-primary" id="btnResolverDisputaConfirmar" data-action="finanzas:confirmarResolverDisputa" style="flex:1;">${t('Confirmar resolución')}</button>
          </div>
        </div>
      </div>
    </div>`;
    },

    /**
     * Modal de Nuevo Adelanto (préstamo entre nodos)
     */
    adelanto() {
        return `
    <div class="modal" id="modalAdelanto" style="display:none; max-width:480px;">
      <div class="modal-header">
        <h2>${t('Nuevo Adelanto')}</h2>
        <button class="btn-icon" data-action="app:closeModal">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body" style="display:block; padding:24px;">
        <div class="form-group">
          <label class="form-label">${t('Nodo Destino (receptor) *')}</label>
          <select class="form-select" id="adelantoDestinoId">
            <option value="">${t('Cargando nodos...')}</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-label">${t('Nodo Origen (opcional — vacío = Casa)')}</label>
          <select class="form-select" id="adelantoOrigenId">
            <option value="">${t('Casa (operador raíz)')}</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-label">${t('Monto *')}</label>
          <input type="number" class="form-input" id="adelantoMonto" min="0.01" step="0.01" placeholder="0.00">
        </div>
        <div class="form-group">
          <label class="form-label">${t('Método')}</label>
          <select class="form-select" id="adelantoMetodo">
            <option value="efectivo">${t('Efectivo')}</option>
            <option value="transferencia">${t('Transferencia')}</option>
            <option value="yape">Yape</option>
            <option value="plin">Plin</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-label">${t('Referencia (opcional)')}</label>
          <input type="text" class="form-input" id="adelantoReferencia" placeholder="${t('Nº operación, etc.')}">
        </div>
        <div class="form-group">
          <label class="form-label">${t('Tipo de crédito')}</label>
          <select class="form-select" id="adelantoTipoCredito">
            <option value="1">${t('Préstamo (devolvible)')}</option>
            <option value="0">${t('Crédito propio (no devolvible)')}</option>
          </select>
          <div class="form-hint" id="adelantoTipoCreditoHint" style="font-size:0.75rem;color:var(--text-dim);margin-top:4px">
            ${t('Préstamo: el nodo deberá devolver este monto. Crédito propio: es capital del nodo, no se devuelve.')}
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">${t('Notas (opcional)')}</label>
          <textarea class="form-input" id="adelantoNotas" rows="2" placeholder="${t('Observaciones...')}"></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-action="app:closeModal">${t('Cancelar')}</button>
        <button class="btn btn-primary" id="btnGuardarAdelanto" data-action="finanzas:saveAdelanto">
          ${icon('hand-coins')}
          ${t('Registrar Adelanto')}
        </button>
      </div>
    </div>`;
    },

    /**
     * Modal de Nueva Liquidación
     */
    liquidacion() {
        return `
    <div class="modal" id="modalLiquidacion" style="display:none; max-width:500px;">
      <div class="modal-header">
        <h2>${t('Nueva Liquidación')}</h2>
        <button class="btn-icon" data-action="app:closeModal">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body" style="display:block; padding:24px;">
        <div class="form-group">
          <label class="form-label">${t('Tipo de Nodo *')}</label>
          <select class="form-select" id="liqTipoEntidad" data-action="finanzas:onTipoNodoChange">
            <option value="punto_venta">${t('Punto de Venta')}</option>
            <option value="representante">${t('Representante')}</option>
            <option value="operador">${t('Operador')}</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-label">${t('Nodo *')}</label>
          <select class="form-select" id="liqEntidadId">
            <option value="">${t('Cargando...')}</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-label">${t('Monto *')}</label>
          <input type="number" class="form-input" id="liqMonto" min="0.01" step="0.01" placeholder="0.00">
        </div>
        <div class="form-group">
          <label class="form-label">${t('Método de Pago')}</label>
          <select class="form-select" id="liqMetodo">
            <option value="efectivo">${t('Efectivo')}</option>
            <option value="transferencia">${t('Transferencia')}</option>
            <option value="yape">Yape</option>
            <option value="plin">Plin</option>
            <option value="cheque">${t('Cheque')}</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-label">${t('Referencia (opcional)')}</label>
          <input type="text" class="form-input" id="liqReferencia" placeholder="${t('Nº operación, cheque, etc.')}">
        </div>
        <div class="form-group">
          <label class="form-label">${t('Notas (opcional)')}</label>
          <textarea class="form-input" id="liqNotas" rows="2" placeholder="${t('Observaciones...')}"></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-action="app:closeModal">${t('Cancelar')}</button>
        <button class="btn btn-primary" id="btnGuardarLiq" data-action="finanzas:saveLiquidacion">
          ${icon('banknote')}
          ${t('Registrar Pago')}
        </button>
      </div>
    </div>`;
    },

    /**
     * Modal de Contrato (Sistema Contable v2.0)
     */
    contrato() {
        return contratoModal();
    },

    /**
     * Modal de Nodo (CRUD unificado para árbol fractal)
     */
    // Delegado a modals/nodo-modal.js para mantener este archivo legible.
    // platform-nodos.js sigue funcionando identico: todos los IDs del DOM
    // se conservan, solo cambia el orden visual en 6 secciones agrupadas.
    nodo() {
        return nodoModal();
    },

    /**
     * Modal para Mover Nodo a otro padre
     */
    moverNodo() {
        return `
    <div class="modal" id="modalMoverNodo" style="display:none; max-width:500px;">
      <div class="modal-header">
        <h2>${icon('shuffle')} ${t('Mover Nodo')}</h2>
        <button class="btn-icon" data-action="app:closeModal">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body" style="display:block; padding:24px;">
        <input type="hidden" id="moverNodoId">

        <div class="form-group" style="margin-bottom:20px;">
          <label class="form-label">${t('Nodo a mover')}</label>
          <div style="padding:12px; background:var(--bg-subtle); border-radius:6px;">
            <strong id="moverNodoNombre">-</strong>
            <span style="color:var(--text-muted); margin-left:8px;" id="moverNodoTipo">-</span>
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">${t('Nuevo nodo padre *')}</label>
          <select class="form-select" id="moverNuevoPadre" required style="max-height:200px;">
            <option value="">${t('Seleccionar destino...')}</option>
          </select>
          <div class="form-hint">${t('El nodo y todos sus descendientes se moverán bajo el nuevo padre.')}</div>
        </div>

        <div style="margin-top:16px; padding:12px; background:rgba(218,54,51,0.1); border-radius:6px; border:1px solid var(--accent-red);">
          <strong style="color:var(--accent-red);">${icon('alert-triangle', '', { style: 'filter:brightness(0) saturate(100%) invert(27%) sepia(94%) saturate(2500%) hue-rotate(350deg);' })} ${t('Precaución')}</strong>
          <p style="margin:8px 0 0; font-size:13px; color:var(--text-secondary);">
            ${t('Mover un nodo afecta toda su rama descendiente. Los paths y profundidades se recalcularán automáticamente.')}
          </p>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-action="app:closeModal">${t('Cancelar')}</button>
        <button class="btn btn-primary" data-action="nodos:moverNodo">
          ${icon('check')}
          ${t('Mover Nodo')}
        </button>
      </div>
    </div>`;
    },

    /**
     * Modal Genérico para contenido dinámico
     */
    generic() {
        return `
    <div class="modal" id="modalGeneric" style="display:none; max-width:800px;">
      <div class="modal-header">
        <h2 id="modalGenericTitle">${t('Detalle')}</h2>
        <button class="btn-icon" data-action="app:closeModal">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body">
        <!-- showGenericModal alterna inline:
             - default (texto plano): display:block + padding (legibilidad).
             - { tabbed:true }: display:contents para que .modal-tabs y
               .modal-content participen del flex de .modal-body (sidebar
               horizontal, mismo patrón que modalContrato y modalNodo). -->
        <div id="modalGenericContent" style="display:block; padding:20px;"></div>
      </div>
      <div id="modalGenericFooter" class="modal-footer">
        <button class="btn btn-secondary" data-action="app:copyGenericContentToClipboard">
          ${icon('copy')}
          ${t('Copiar')}
        </button>
        <button class="btn btn-primary" data-action="app:closeModal">${t('Cerrar')}</button>
      </div>
    </div>`;
    },

    /**
     * Modal de Crear/Editar Promocion (Constructor Visual)
     */
    promocion() {
        return `
    <div class="modal" id="modalPromocion" style="display:none; max-width:980px;">
      <div class="modal-header">
        <h2 id="modalPromocionTitle">${t('Nueva Promocion')}</h2>
        <button class="btn-icon" data-action="app:closeModal">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body" style="display:block; padding:24px; max-height:70vh; overflow-y:auto;">
        <input type="hidden" id="promoId">

        <!-- PRESENTACIÓN EN MIS PROMOCIONES: el copy que lee el jugador pertenece a la
             promoción (contrato compartido copy-editorial-de-promocion; los topes salen
             de ahí, nunca se duplican acá). El de la ceremonia de entrega es otro
             contrato y vive en la sección de recompensa. -->
        <fieldset class="promo-copy-editorial">
          <legend>${t('Presentación en Mis promociones')}</legend>
          <div class="form-group">
            <label class="form-label" for="promoNombre">${t('Título *')}</label>
            <input type="text" class="form-input" id="promoNombre" maxlength="120" placeholder="${t('Ej: Bono de bienvenida')}" required>
            <div class="form-hint">${t('Encabeza la card y el detalle en Mis promociones.')}</div>
          </div>
          <div class="form-group">
            <label class="form-label" for="promoCardTeaser">${t('Texto breve de la card')}</label>
            <input type="text" class="form-input" id="promoCardTeaser" maxlength="${LIMITES_COPY_EDITORIAL.cardTeaser}" placeholder="${t('Ej: Tu bonus de bienvenida ya está activo.')}">
            <div class="form-hint">${t('Una o dos líneas. Vacío: el jugador ve el texto estándar del Centro.')}</div>
          </div>
          <div class="form-group">
            <label class="form-label" for="promoDescripcion">${t('Explicación completa')}</label>
            <textarea class="form-input" id="promoDescripcion" rows="4" maxlength="${LIMITES_COPY_EDITORIAL.detailBody}" placeholder="${t('Explica cómo funciona, qué debe hacer y cualquier condición importante.')}"></textarea>
            <div class="form-hint">${t('Se muestra en «Cómo funciona» al abrir el detalle. Los montos y progresos se calculan automáticamente.')}</div>
          </div>
          <div class="form-group" style="margin-bottom:0;">
            <label class="form-label" for="promoCompletionBody">${t('Qué ocurre al completar (opcional)')}</label>
            <textarea class="form-input" id="promoCompletionBody" rows="2" maxlength="${LIMITES_COPY_EDITORIAL.completionBody}" placeholder="${t('Ej: Al llegar al 100 %, el beneficio queda liberado.')}"></textarea>
            <div class="form-hint">${t('Vacío: la sección «Al completar» se omite en el detalle.')}</div>
          </div>
        </fieldset>

        <!-- ALCANCE (Global o scoped a un nodo) — MarketingModule._populateScopeNodoSelector pobla las opciones -->
        <div class="form-group">
          <label class="form-label">${t('Alcance')}</label>
          <select class="form-select" id="promoScopeNodoId">
            <option value="">${t('Global (todo el brand)')}</option>
          </select>
        </div>

        <!-- AUDIENCIAS: dónde puede ORIGINARSE una concesión. El flag gobierna
             el origen, no dónde consulta después el jugador un beneficio que ya
             es suyo — una obligación concedida pertenece al beneficiario. -->
        <div class="form-group">
          <label class="form-label">${t('Puede activarse en')}</label>
          <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(210px,1fr));gap:8px;padding:10px;background:var(--bg-tertiary);border-radius:8px;">
            <label style="display:flex;align-items:flex-start;gap:7px;cursor:pointer;">
              <input type="checkbox" class="promoAudiencia" value="customer" id="promoAudienciaCustomer" checked>
              <span><strong>${t('Customer')}</strong><br><small>${t('Jugador identificado en la web')}</small></span>
            </label>
            <label style="display:flex;align-items:flex-start;gap:7px;cursor:pointer;">
              <input type="checkbox" class="promoAudiencia" value="b2b.customer" id="promoAudienciaB2b">
              <span><strong>${t('B2B')}</strong><br><small>${t('Jugador identificado por el launch')}</small></span>
            </label>
            <label style="display:flex;align-items:flex-start;gap:7px;cursor:pointer;">
              <input type="checkbox" class="promoAudiencia" value="vlt.customer" id="promoAudienciaVltCustomer">
              <span><strong>${t('VLT · jugador')}</strong><br><small>${t('Jugador identificado en la terminal')}</small></span>
            </label>
            <label style="display:flex;align-items:flex-start;gap:7px;cursor:pointer;">
              <input type="checkbox" class="promoAudiencia" value="vlt.turn" id="promoAudienciaVltTurn">
              <span><strong>${t('VLT · turno')}</strong><br><small>${t('Turno anónimo de la terminal')}</small></span>
            </label>
          </div>
          <div class="form-hint">${t('El punto de venta y su herencia se configuran en Alcance; aquí no se duplican.')}</div>
          <!-- Aviso de capacidad: por qué esta combinación audiencia × recompensa
               quedará en borrador. Lo llena MarketingModule._refrescarAvisoDeCapacidad
               con la matriz del backend; el backend sigue siendo la autoridad. -->
          <div id="promoAvisoCapacidad" style="display:none; margin-top:10px;"></div>
        </div>

        <!-- TRIGGER (Cards) -->
        <div class="form-group">
          <label class="form-label">${t('Cuando se activa *')}</label>
          <div id="promoTriggerCards" class="promo-trigger-grid"></div>
        </div>

        <!-- RECOMPENSA -->
        <div class="form-group">
          <label class="form-label">${t('Tipo de recompensa *')}</label>
          <select class="form-select" id="promoRewardType" data-action="marketing:onRewardTypeChange">
            <option value="">${t('Seleccionar...')}</option>
          </select>
          <div id="promoRewardFields" style="margin-top:12px;"></div>
        </div>

        <section class="promo-player-previews" aria-labelledby="promoPlayerPreviewsTitle">
          <div class="promo-player-previews__heading">
            <div>
              <span class="promo-player-previews__eyebrow">${t('Vista del jugador')}</span>
              <h3 id="promoPlayerPreviewsTitle">${t('Previsualización de la promoción')}</h3>
            </div>
            <div class="promo-player-previews__tools">
              <label for="promoPreviewLocale">${t('Idioma de la vista previa')}</label>
              <select class="form-select" id="promoPreviewLocale">
                <option value="es">ES</option><option value="pt">PT</option><option value="en">EN</option><option value="ru">RU</option>
              </select>
              <span class="promo-player-previews__sample">${t('Datos de progreso de ejemplo')}</span>
            </div>
          </div>
          <div class="promo-player-previews__grid promo-player-previews__grid--tres">
            <article class="promo-player-preview-panel">
              <h4>${t('Card en Mis promociones')}</h4>
              <div id="promoMenuPreview"></div>
            </article>
            <article class="promo-player-preview-panel">
              <h4>${t('Detalle de la promoción')}</h4>
              <div id="promoDetailPreview"></div>
            </article>
            <article class="promo-player-preview-panel">
              <h4>${t('Entrega de la recompensa')}</h4>
              <div id="promoRewardPreview"></div>
            </article>
          </div>
          <!-- Host del iframe con la Experience REAL del escenario elegido. La
               maqueta de arriba explica la promocion; esta pinta la ceremonia
               tal cual la vera el jugador, con su propio CSS y su WebGL
               aislados del formulario. -->
          <article class="promo-player-preview-panel promo-player-preview-panel--real">
            <h4>${t('Experiencia real de entrega')}</h4>
            <div id="promoRealExperiencePreview"></div>
          </article>
        </section>

        <!-- CONDICIONES -->
        <div class="form-group">
          <label class="form-label">${t('Aplicar a')}</label>
          <div style="display:flex; gap:16px; margin-bottom:8px;">
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;">
              <input type="radio" name="promoCondMode" value="todos" checked data-action="marketing:onCondModeChange"> ${t('Todos')}
            </label>
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;">
              <input type="radio" name="promoCondMode" value="filtrado" data-action="marketing:onCondModeChange"> ${t('Solo si cumple condiciones')}
            </label>
          </div>
          <div id="promoCondBuilder" style="display:none; background:var(--bg-tertiary); padding:12px; border-radius:8px;">
            <div id="promoCondRows"></div>
            <button class="btn btn-sm" style="margin-top:8px; font-size:12px; padding:4px 12px; background:var(--bg-secondary); border:1px dashed var(--border-color); color:var(--text-secondary);" data-action="marketing:addConditionRow">
              + ${t('Agregar condicion')}
            </button>
          </div>
          <div id="promoReglasConservadas" style="display:none; margin-top:8px;"></div>
        </div>

        <!-- OPCIONES AVANZADAS -->
        <div style="border-top:1px solid var(--border-color); margin-top:16px; padding-top:12px;">
          <button class="btn btn-sm" id="promoAdvancedToggle" style="font-size:13px; padding:4px 12px; background:transparent; color:var(--text-secondary); border:none; cursor:pointer;"
            data-action="marketing:toggleAdvanced">
            ▶ ${t('Opciones avanzadas')}
          </button>
          <div id="promoAdvancedPanel" style="display:none; margin-top:12px;">

            <!-- CODIGO -->
            <div class="form-group">
              <label class="form-label">${t('Codigo')}</label>
              <input type="text" class="form-input" id="promoCodigo" placeholder="${t('AUTO_GENERADO')}" style="text-transform:uppercase;">
              <div class="form-hint">${t('Se genera automaticamente si se deja vacio')}</div>
            </div>

            <!-- LIMITES -->
            <div class="form-group">
              <label style="display:flex; align-items:center; gap:6px; cursor:pointer;">
                <input type="checkbox" id="promoLimitCliente" data-action="marketing:toggleLimitCliente">
                ${t('Limitar usos por cliente')}
              </label>
              <input type="number" class="form-input" id="promoMaxCliente" value="1" min="1" style="display:none; margin-top:6px; width:100px;">
              <div class="form-hint" id="promoLimitClienteExigido" style="display:none; color:var(--accent-orange);">${t('Visita con recompensa monetaria: obligatorio. Cada canje la dispara; sin límite no se activa.')}</div>
            </div>

            <div class="form-group">
              <label style="display:flex; align-items:center; gap:6px; cursor:pointer;">
                <input type="checkbox" id="promoLimitGlobal" data-action="marketing:toggleLimitGlobal">
                ${t('Limitar usos globales')}
              </label>
              <input type="number" class="form-input" id="promoMaxGlobal" value="" min="1" style="display:none; margin-top:6px; width:100px;">
            </div>

            <div class="form-group">
              <label style="display:flex; align-items:center; gap:6px; cursor:pointer;">
                <input type="checkbox" id="promoLimitPresupuesto" data-action="marketing:toggleLimitPresupuesto">
                ${t('Presupuesto maximo')}
              </label>
              <!-- placeholder con símbolo: lo actualiza MarketingModule según la moneda del scope -->
              <input type="number" class="form-input" id="promoPresupuesto" value="" min="1" placeholder="Monto (${MonedaService.getSimboloActual()})" style="display:none; margin-top:6px; width:140px;">
            </div>

            <!-- ESPERA DE CAPACIDAD: para quien todavía no puede gastar el bonus (p. ej. solo juega en un nodo de juego) -->
            <div class="form-group">
              <label style="display:flex; align-items:center; gap:6px; cursor:pointer;">
                <input type="checkbox" id="promoEsperaCheck" data-action="marketing:toggleEspera">
                ${t('Esperar a que el jugador pueda usar la recompensa (horas)')}
              </label>
              <input type="number" class="form-input" id="promoEsperaHoras" value="" min="1" step="1" style="display:none; margin-top:6px; width:100px;">
              <small style="display:block; margin-top:4px; color:var(--text-secondary);">${t('Si el jugador todavia no puede usar el bonus, la recompensa concedida espera este plazo. Sin marcar: no se concede.')}</small>
            </div>

            <!-- HORARIO -->
            <div class="form-group">
              <label style="display:flex; align-items:center; gap:6px; cursor:pointer;">
                <input type="checkbox" id="promoHorarioCheck" data-action="marketing:toggleHorario">
                ${t('Horario especifico')}
              </label>
              <div id="promoHorarioPanel" style="display:none; margin-top:8px; padding:10px; background:var(--bg-tertiary); border-radius:8px;">
                <div style="display:flex; gap:8px; flex-wrap:wrap; margin-bottom:8px;">
                  <label style="display:flex;align-items:center;gap:4px;cursor:pointer;font-size:13px;"><input type="checkbox" class="promoDia" value="1">L</label>
                  <label style="display:flex;align-items:center;gap:4px;cursor:pointer;font-size:13px;"><input type="checkbox" class="promoDia" value="2">M</label>
                  <label style="display:flex;align-items:center;gap:4px;cursor:pointer;font-size:13px;"><input type="checkbox" class="promoDia" value="3">X</label>
                  <label style="display:flex;align-items:center;gap:4px;cursor:pointer;font-size:13px;"><input type="checkbox" class="promoDia" value="4">J</label>
                  <label style="display:flex;align-items:center;gap:4px;cursor:pointer;font-size:13px;"><input type="checkbox" class="promoDia" value="5">V</label>
                  <label style="display:flex;align-items:center;gap:4px;cursor:pointer;font-size:13px;"><input type="checkbox" class="promoDia" value="6">S</label>
                  <label style="display:flex;align-items:center;gap:4px;cursor:pointer;font-size:13px;"><input type="checkbox" class="promoDia" value="0">D</label>
                </div>
                <div style="display:flex; gap:12px; align-items:center;">
                  <label style="font-size:13px;">${t('Desde:')}</label>
                  <input type="time" class="form-input" id="promoHoraInicio" value="18:00" style="width:120px;">
                  <label style="font-size:13px;">${t('Hasta:')}</label>
                  <input type="time" class="form-input" id="promoHoraFin" value="22:00" style="width:120px;">
                </div>
              </div>
            </div>

            <!-- WAGERING -->
            <div class="form-group">
              <label style="display:flex; align-items:center; gap:6px; cursor:pointer;">
                <input type="checkbox" id="promoWageringCheck" data-action="marketing:toggleWagering">
                ${t('Requiere wagering (anti-fraude)')}
              </label>
              <div id="promoWageringPanel" style="display:none; margin-top:8px; padding:10px; background:var(--bg-tertiary); border-radius:8px;">
                <div style="display:flex; gap:12px; align-items:center;">
                  <label style="font-size:13px;">${t('Multiplicador:')}</label>
                  <input type="number" class="form-input" id="promoWageringMult" value="5" min="1" step="0.5" style="width:80px;">
                  <span style="font-size:13px; color:var(--text-secondary);">x</span>
                  <label style="font-size:13px; margin-left:12px;">${t('Plazo:')}</label>
                  <input type="number" class="form-input" id="promoWageringHoras" value="168" min="1" style="width:80px;">
                  <span style="font-size:13px; color:var(--text-secondary);">${t('horas')}</span>
                </div>
                <!-- Medio de liberación: obligatorio con wagering. Decide a qué
                     bolsa vuelve el dinero cuando el jugador completa el
                     rollover; sin él la promoción no se puede guardar. -->
                <div style="display:flex; gap:12px; align-items:center; margin-top:10px;">
                  <label style="font-size:13px;">${t('Al completar, liberar a:')}</label>
                  <select class="form-input" id="promoWageringProcedencia" data-action="marketing:cambiarProcedenciaWagering" style="width:150px;">
                    <option value="cash">${t('Efectivo (caja)')}</option>
                    <option value="pasarela">${t('Pasarela')}</option>
                  </select>
                  <span id="promoWageringFronteraWrap" style="display:none; align-items:center; gap:8px;">
                    <label style="font-size:13px;">${t('Proveedor:')}</label>
                    <select class="form-input" id="promoWageringFrontera" style="width:180px;">
                      <option value="">${t('Seleccionar...')}</option>
                    </select>
                  </span>
                </div>
                <div style="font-size:12px; color:var(--text-secondary); margin-top:6px;">
                  ${t('El dinero del bonus queda bloqueado hasta cumplir el rollover; al completarlo vuelve retirable por este medio.')}
                </div>
              </div>
            </div>

            <!-- DATOS EXIGIDOS AL JUGADOR -->
            <div class="form-group">
              <label style="display:flex; align-items:center; gap:6px; cursor:pointer;">
                <input type="checkbox" id="promoRequisitosCheck" data-action="marketing:toggleRequisitos">
                ${t('Exige datos al jugador (anti-abuso)')}
              </label>
              <div id="promoRequisitosPanel" style="display:none; margin-top:8px; padding:10px; background:var(--bg-tertiary); border-radius:8px;">
                <label style="display:flex; align-items:center; gap:6px; cursor:pointer; font-size:13px;">
                  <input type="checkbox" id="promoRequisitoDocumento" checked>
                  ${t('Documento fiscal (CPF/CNPJ en Brasil, DNI en Perú)')}
                </label>
                <div style="font-size:12px; color:var(--text-secondary); margin-top:6px;">
                  ${t('El jugador no puede registrarse sin documento válido, y un mismo documento cobra el bono UNA sola vez aunque cree otra cuenta.')}
                </div>
              </div>
            </div>

            <!-- HITOS -->
            <div class="form-group">
              <label style="display:flex; align-items:center; gap:6px; cursor:pointer;">
                <input type="checkbox" id="promoHitosCheck" data-action="marketing:toggleHitos">
                ${t('Tiene hitos progresivos')}
              </label>
              <div id="promoHitosPanel" style="display:none; margin-top:8px;">
                <div id="promoHitosRows"></div>
                <button class="btn btn-sm" style="margin-top:8px; font-size:12px; padding:4px 12px; background:var(--bg-secondary); border:1px dashed var(--border-color); color:var(--text-secondary);" data-action="marketing:addHitoRow">
                  + ${t('Agregar hito')}
                </button>
              </div>
            </div>

            <!-- VIGENCIA -->
            <div class="form-group">
              <label class="form-label">${t('Vigencia')}</label>
              <div style="display:flex; gap:12px; align-items:center;">
                <label style="font-size:13px;">${t('Desde:')}</label>
                <input type="datetime-local" class="form-input" id="promoVigenteDesde" style="width:200px;">
                <label style="font-size:13px;">${t('Hasta:')}</label>
                <input type="datetime-local" class="form-input" id="promoVigenteHasta" style="width:200px;">
              </div>
              <div class="form-hint">${t('Dejar vacio para sin limite')}</div>
            </div>

            <!-- PRIORIDAD -->
            <div class="form-group">
              <label class="form-label">${t('Prioridad')}</label>
              <input type="number" class="form-input" id="promoPrioridad" value="100" min="1" max="999" style="width:80px;">
              <div class="form-hint">${t('Mayor numero = mayor prioridad de evaluacion')}</div>
            </div>

          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" data-action="app:closeModal">${t('Cancelar')}</button>
        <button class="btn btn-primary" id="promoSaveBtn" data-action="marketing:guardarPromocion">${t('Guardar')}</button>
      </div>
    </div>`;
    },

    // Simulador delegado a LotowheelModalTemplates (lotowheel-modals.js)
    simulator() {
        if (typeof LotowheelModalTemplates === 'undefined') return '';
        return LotowheelModalTemplates.simulator();
    },

    // Modal del Pozo Acumulado — delegado a modals/pozo-acumulado-modal.js
    // (cinco apartados sobre TabbedModal, como nodo y contrato).
    pozoComun() {
        return pozoAcumuladoModal();
    },

    /**
     * Modal del Dashboard Profesional de Estadísticas de Nodo
     * KPIs, gráficos Chart.js, info contrato, exportación
     */
    nodeStatisticsDashboard() {
        return `
    <div class="modal" id="modalNodeStatsDashboard" style="display:none; max-width:1100px;">
      <div class="modal-header">
        <h3 id="nodeStatsDashboardTitle">${t('Estadisticas')}</h3>
        <button class="modal-close" data-action="nodeStats:close">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body" style="flex-direction:column; display:flex; padding:20px; max-height:80vh; overflow-y:auto;">

        <!-- Filtros de periodo -->
        <div class="node-stats-period-filters">
          <button class="btn btn-sm stats-date-btn active" data-period="hoy" data-action="nodeStats:setPeriod">${t('Hoy')}</button>
          <button class="btn btn-sm stats-date-btn" data-period="ayer" data-action="nodeStats:setPeriod">${t('Ayer')}</button>
          <button class="btn btn-sm stats-date-btn" data-period="semana" data-action="nodeStats:setPeriod">${t('Semana')}</button>
          <button class="btn btn-sm stats-date-btn" data-period="mes" data-action="nodeStats:setPeriod">${t('Mes')}</button>
          <button class="btn btn-sm stats-date-btn" data-period="ultimo_corte" data-action="nodeStats:setPeriod">${t('Ultimo Corte')}</button>
          <button class="btn btn-sm stats-date-btn" data-period="rango" data-action="nodeStats:toggleCustomRange">${t('Rango')}</button>
        </div>
        <div id="nodeStatsRangeLabel" class="node-stats-range-label"></div>

        <!-- Rango personalizado -->
        <div id="nodeStatsCustomRangeInputs" style="display:none; margin-bottom:16px;">
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">${t('Desde')}</label>
              <input type="date" class="form-input" id="nodeStatsDesde">
            </div>
            <div class="form-group">
              <label class="form-label">${t('Hasta')}</label>
              <input type="date" class="form-input" id="nodeStatsHasta">
            </div>
            <div class="form-group" style="display:flex; align-items:flex-end;">
              <button class="btn btn-primary btn-sm" data-action="nodeStats:applyCustomRange">${t('Aplicar')}</button>
            </div>
          </div>
        </div>

        <!-- Loading -->
        <div id="nodeStatsDashboardLoading" class="node-stats-loading" style="display:none;">
          ${icon('refresh-cw', 'spin', { style: 'width:24px; height:24px;' })}
          <div>${t('Cargando estadisticas...')}</div>
        </div>

        <!-- Contenedor principal del dashboard -->
        <div id="nodeStatsDashboardContent" style="display:none;">
          <div id="nodeStatsDashboardErrorBanner" class="node-stats-no-data" style="display:none;"></div>
          <!-- Barra de pestañas: Nodo / Jugadores / Tickets -->
          <div class="node-stats-tabs">
            <button class="node-stats-tab active" data-action="nodeStats:setTab" data-tab="nodo">${t('Nodo')}</button>
            <button class="node-stats-tab" data-action="nodeStats:setTab" data-tab="jugadores">${t('Jugadores')}</button>
            <button class="node-stats-tab" data-action="nodeStats:setTab" data-tab="tickets">${t('Tickets')}</button>
          </div>

          <!-- Panel NODO (producción/finanzas) -->
          <div class="node-stats-panel" data-panel="nodo">
            <div id="nodeStatsDashboardKpiContainer" class="node-stats-kpi-grid"></div>
            <div id="nodeStatsDashboardChartsContainer"></div>
            <div id="nodeStatsDashboardContractInfo"></div>
            <div id="nodeStatsDashboardCortesHistory"></div>
          </div>

          <!-- Panel JUGADORES -->
          <div class="node-stats-panel" data-panel="jugadores" style="display:none;">
            <div id="nodeStatsDashboardJugadores"></div>
          </div>

          <!-- Panel TICKETS -->
          <div class="node-stats-panel" data-panel="tickets" style="display:none;">
            <div id="nodeStatsDashboardTickets"></div>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <div class="node-stats-export-row">
          <button class="btn btn-secondary" data-action="nodeStats:copyText">
            ${icon('copy')} ${t('Copiar Texto')}
          </button>
          <button class="btn btn-secondary" data-action="nodeStats:downloadImage">
            ${icon('download')} ${t('Imagen')}
          </button>
          <button class="btn btn-secondary" data-action="nodeStats:shareWhatsapp">
            ${t('Compartir')}
          </button>
        </div>
        <button class="btn btn-primary" data-action="nodeStats:close">${t('Cerrar')}</button>
      </div>
    </div>`;
    },

    /**
     * Modal shell para el SetupWizard (dispositivos y nodos).
     * Contenido dinámico — renderizado por setup-wizard-engine.js.
     */
    setupWizard() {
        return `
    <div class="modal" id="modalSetupWizard" style="display:none; max-width:680px;">
      <div class="modal-header">
        <h2 id="wizardTitle">Setup Wizard</h2>
        <button class="btn-icon" data-action="app:closeModal">
          ${icon('x')}
        </button>
      </div>
      <div class="modal-body" style="display:flex; min-height:340px;">
        <div class="modal-tabs" id="wizardTabs" style="width:160px;">
          <!-- Tabs renderizadas por engine -->
        </div>
        <div class="modal-content" id="wizardContent">
          <!-- Paso actual renderizado por engine -->
        </div>
      </div>
      <div class="modal-footer">
        <div class="wizard-footer-nav">
          <button class="btn btn-secondary" id="wizardBtnBack" data-action="wizard:prev" style="display:none;">
            ← ${t('Atrás')}
          </button>
          <div class="wizard-footer-right">
            <button class="btn btn-secondary" data-action="app:closeModal">${t('Cancelar')}</button>
            <button class="btn btn-primary" id="wizardBtnNext" data-action="wizard:next">${t('Siguiente')} →</button>
          </div>
        </div>
      </div>
    </div>`;
    },

    injectAll() {
        const overlay = document.getElementById('modalOverlay');
        if (!overlay) {
            console.error('[Modals] No se encontro #modalOverlay');
            return;
        }

        overlay.innerHTML =
            this.lotowheelConfig() +
            this.dispositivo() +
            this.bloqueo() +
            this.sorteo() +
            this.usuario() +
            this.moverUsuario() +
            this.stats() +
            this.corte() +
            this.corteCascada() +
            this.resolverDisputaModal() +
            this.historialCuenta() +
            this.ajusteCuenta() +
            this.adelanto() +
            this.pagoLiquidacion() +
            this.liquidacion() +
            this.contrato() +
            this.nodo() +
            this.moverNodo() +
            this.generic() +
            this.promocion() +
            this.simulator() +
            this.pozoComun() +
            this.nodeStatisticsDashboard() +
            this.setupWizard() +
            ConfirmacionDestructiva.template();
    },
};

// Auto-inyectar cuando el DOM esté listo
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => ModalTemplates.injectAll());
} else {
    ModalTemplates.injectAll();
}
